import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';

import ScreenReaderOnly from '../../A11y/ScreenReaderOnly';

import { colorPeacock028, colorPeacock048, spaceStackDefault, spaceStackQuad } from '../../../theme/settings';

const Logo = () => (
  <StyledLogo to="/">
    <ScreenReaderOnly>Visit Other Pieces home page</ScreenReaderOnly>
    <StyledLogoIcon viewBox="0 0 1208 72" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.859 35.617c0 11.652-2.88 20.509-8.638 26.571-5.758 6.063-14.189 9.094-25.292 9.094-10.944 0-19.342-3.047-25.196-9.141C2.91 56.047 0 47.174 0 35.523 0 23.997 2.895 15.203 8.685 9.14 14.507 3.047 22.954 0 34.025 0c11.103 0 19.517 3.015 25.244 9.046 5.727 6.031 8.59 14.888 8.59 26.571zm-48.007 0c0 13.388 4.692 20.082 14.077 20.082 4.772 0 8.304-1.626 10.594-4.878 2.323-3.252 3.484-8.32 3.484-15.204 0-6.915-1.177-12.014-3.531-15.298-2.323-3.316-5.806-4.973-10.451-4.973-9.449 0-14.173 6.757-14.173 20.271zM160.103 70.335h-18.85V16.388h-17.036V1.089h52.874v15.299h-16.988v53.947zM295.725 70.335H276.78V42.106h-21.904v28.229h-18.945V1.089h18.945V26.76h21.904V1.09h18.945v69.245zM401.14 70.335h-41.422V1.089h41.422v15.014h-22.572v10.894h20.901v15.014h-20.901v13.072h22.572v15.252zM481.072 45.137v25.198h-18.85V1.089h22.858c18.961 0 28.442 6.82 28.442 20.461 0 8.02-3.945 14.225-11.835 18.614l20.329 30.17h-21.379l-14.793-25.197h-4.772zm0-14.067h3.531c6.585 0 9.878-2.889 9.878-8.667 0-4.768-3.229-7.152-9.687-7.152h-3.722v15.82zM702.114 23.113c0 7.736-2.307 13.72-6.92 17.951-4.581 4.2-11.103 6.3-19.565 6.3h-5.297v22.97h-18.85V1.09h24.147c8.812 0 15.429 1.91 19.851 5.731 4.423 3.821 6.634 9.252 6.634 16.293zm-31.782 9h3.436c2.831 0 5.074-.79 6.728-2.369 1.686-1.579 2.529-3.757 2.529-6.536 0-4.673-2.608-7.01-7.826-7.01h-4.867v15.914zM762.098 70.335V1.089h18.946v69.246h-18.946zM886.458 70.335h-41.421V1.089h41.421v15.014h-22.571v10.894h20.901v15.014h-20.901v13.072h22.571v15.252zM978.607 15.44c-4.486 0-7.985 1.832-10.499 5.495-2.513 3.63-3.769 8.651-3.769 15.061 0 13.325 5.106 19.987 15.318 19.987a31.59 31.59 0 0 0 8.971-1.278 90.235 90.235 0 0 0 8.733-3.079v15.82c-5.822 2.557-12.407 3.836-19.756 3.836-10.53 0-18.611-3.031-24.242-9.094-5.599-6.063-8.399-14.825-8.399-26.287 0-7.167 1.352-13.467 4.056-18.898 2.736-5.43 6.649-9.599 11.739-12.503 5.122-2.937 11.135-4.405 18.039-4.405 7.54 0 14.746 1.626 21.622 4.878l-5.779 14.73a65.216 65.216 0 0 0-7.731-3.031c-2.577-.821-5.344-1.232-8.303-1.232zM1101.3 70.335h-41.42V1.089h41.42v15.014h-22.58v10.894h20.91v15.014h-20.91v13.072h22.58v15.252zM1208 49.305c0 4.294-1.1 8.115-3.29 11.462-2.2 3.315-5.36 5.905-9.5 7.768-4.13 1.831-8.99 2.747-14.55 2.747-4.65 0-8.55-.316-11.7-.947-3.14-.664-6.42-1.8-9.83-3.41V50.251a57.669 57.669 0 0 0 11.22 4.31c3.88 1.01 7.44 1.516 10.69 1.516 2.8 0 4.85-.474 6.15-1.42 1.31-.98 1.96-2.227 1.96-3.742 0-.948-.27-1.769-.81-2.463-.51-.727-1.35-1.453-2.53-2.18-1.15-.725-4.23-2.21-9.26-4.451-4.55-2.053-7.97-4.042-10.26-5.968-2.26-1.926-3.94-4.136-5.06-6.63-1.08-2.495-1.62-5.448-1.62-8.858 0-6.378 2.34-11.351 7.02-14.92 4.67-3.567 11.1-5.351 19.28-5.351 7.22 0 14.58 1.657 22.09 4.973l-5.77 14.446c-6.53-2.968-12.16-4.452-16.9-4.452-2.45 0-4.23.426-5.34 1.278-1.12.853-1.67 1.91-1.67 3.174 0 1.357.7 2.573 2.1 3.647 1.43 1.073 5.28 3.03 11.55 5.873 6.01 2.684 10.18 5.573 12.5 8.667 2.35 3.063 3.53 6.931 3.53 11.604z" />
    </StyledLogoIcon>
  </StyledLogo>
);

const StyledLogo = styled(Link)`
  width: 100%;
  display: block;
  text-decoration: none;

  @media (max-width: 575px) {
    margin: ${spaceStackDefault};
  }

  @media (min-width: 576px) {
    margin: ${spaceStackQuad};
  }

  &:hover,
  &:focus {
    svg {
      fill: ${colorPeacock048};
    }
  }

  &:focus {
    outline: 0.4rem solid ${colorPeacock048};
    outline-offset: 0.8rem;
  }
`;

const StyledLogoIcon = styled.svg`
  width: 100%;
  fill: ${colorPeacock028};
`;

export default Logo;
